import "./App.css";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginScreen from "./screens/LoginScreen";
import MapScreen from "./screens/MapScreen";
import ProtectedRoute from "./utils/ProtectedRoute";
import { LightModeContextProvider } from "./hooks/mode/LightModeContextProvider";
import "core-js/stable";
import "regenerator-runtime/runtime";
import NotFoundScreen from "./screens/NotFoundScreen";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import LegalMentionsPage from "./components/molecules/legalMentionsPage/LegalMentionsPage";
import { getDecryptedItem } from "./utils/cryptoStorage";
import { setCredentials } from "./redux/reducers/authReducer";

function App() {
  const dispatch = useDispatch();
  const [isRehydrated, setIsRehydrated] = useState(false);

  // Runs once on app load (e.g. page refresh). Reads whatever encrypted
  // session data exists in localStorage and restores it into Redux,
  // so the user isn't kicked back to /login just because they refreshed.
  useEffect(() => {
    (async () => {
      try {
        const accessToken = await getDecryptedItem("accessToken");
        const accessRights = await getDecryptedItem("accessRights");

        if (accessToken) {
          dispatch(
            setCredentials({
              accessToken,
              user: { access_rights: accessRights },
            })
          );
        }
      } catch (err) {
        console.error("Failed to rehydrate session:", err);
      } finally {
        setIsRehydrated(true);
      }
    })();
  }, [dispatch]);

  // // Wait until rehydration finishes before rendering routes, otherwise
  // // ProtectedRoute might redirect to /login before the token is restored.
  if (!isRehydrated) {
    return null; // or a loading spinner
  }

  return (
    <div className="App">
      <LightModeContextProvider>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <GoogleReCaptchaProvider
                  reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                >
                  <LoginScreen />
                </GoogleReCaptchaProvider>
              }
            />
            <Route path="/legal-mentions" element={<LegalMentionsPage />} />

            <Route
              path="/action"
              element={
                <ProtectedRoute>
                  <MapScreen />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFoundScreen />} />
          </Routes>
        </BrowserRouter>
      </LightModeContextProvider>
    </div>
  );
}

export default App;